import { TAO_KOE, TaoCookieJar } from './../libs';
const setErrorMessage = function( messageEl, txt ) {
	if ( messageEl ) {
		const text = txt || messageEl.dataset.taoErrorText;
		if ( text ) {
			messageEl.innerHTML = text;
		}
	}
	return messageEl;
};

class NewsletterForm {
	constructor( formEl ) {
		this.formEl = formEl;
		this.stoken = false;
		this.checkVisibility();

		this.formEl.addEventListener( 'submit', ( ev ) => {
			ev.preventDefault();
			this.submit();
		} );

		const inputEls = this.formEl.querySelectorAll( 'input[type=email]' );
		inputEls.forEach( ( inputEl ) => {
			inputEl.addEventListener( 'invalid', ( ev ) => {
				ev.preventDefault();
				this.showErrorEmail( 'Bitte geben Sie eine gültige E-Mail Adresse ein.' );
				return false;
			} );
		} );
	}

	checkVisibility() {
		const formEl = this.formEl;
		if ( formEl && TaoCookieJar.get_cookie( 'nl_reg' ) ) {
			const blockSectionEl = formEl.closest( '.mdl_blocksection' );
			// Remove Newsletter Block.
			if ( blockSectionEl ) {
				blockSectionEl.remove();
			}
		}
	}

	showSuccess( text ) {
		const messageEls = this.formEl.querySelectorAll( '.tao-notification' );
		messageEls.forEach( ( messageEl ) => {
			if ( messageEl.classList.contains( 'message-success' ) ) {
				messageEl.classList.remove( 'en_hidden' );
				setErrorMessage( messageEl.querySelector( '.notification' ), text );
			} else {
				messageEl.classList.add( 'en_hidden' );
			}
		} );
	}

	showError( text ) {
		const messageEls = this.formEl.querySelectorAll( '.tao-notification' );
		messageEls.forEach( ( messageEl ) => {
			if ( messageEl.classList.contains( 'message-error' ) ) {
				messageEl.classList.remove( 'en_hidden' );
				setErrorMessage( messageEl.querySelector( '.notification' ), text );
			} else {
				messageEl.classList.add( 'en_hidden' );
			}
		} );
	}

	showErrorEmail( text ) {
		const rowEls = this.formEl.querySelectorAll( '[data-tao-row=email]' );
		rowEls.forEach( ( rowEl ) => {
			rowEl.classList.add( 'row_has_message', 'has_error' );
			const messageEl = rowEl.querySelector( '.input_row_message.error' );
			setErrorMessage( messageEl, text );
		} );
	}

	hideAllNotifications() {
		const messageEls = this.formEl.querySelectorAll( '.tao-notification' );
		messageEls.forEach( ( messageEl ) => messageEl.classList.add( 'en_hidden' ) );

		const rowEls = this.formEl.querySelectorAll( '.row_has_message' );
		rowEls.forEach( ( rowEl ) => rowEl.classList.remove( 'row_has_message', 'has_error' ) );
	}

	async getSToken() {
		// Get previously cached stoken.
		if ( this._stoken ) {
			return this._stoken;
		}

		// Initialise stoken on Shop pages ( if empty, but available ).
		if ( window._stoken ) {
			// Get Stoken from window.
			return window._stoken;
		}

		// Get stoken from another input on page.
		const inputEls = document.querySelectorAll( 'input[name=stoken]' );
		for ( const inputEl of inputEls ) {
			if ( inputEl.value ) {
				return inputEl.value;
			}
		}

		// Try to get from a previous promise.
		if ( window.ACL_USER_DATA ) {
			return window.ACL_USER_DATA
				.then( ( { data } ) => data.user.stoken );
		}

		// Fetch stoken from Controller.
		return await fetch( '/index.php?cl=userdata', {
			method: 'GET',
			credentials: 'include',
			mode: 'no-cors',
		} )
			.then( ( res ) => res.json() )
			.then( ( { data } ) => data.user.stoken );
	}

	async submit() {
		const formEl = this.formEl;
		const stokenEl = formEl.querySelector( 'input[name=stoken]' );

		// Set stoken value.
		const value = await this.getSToken();
		if ( value ) {
			this._stoken = value;
			stokenEl.value = value;
		}

		// Prepare data for submit.
		const params = new FormData( formEl );
		params.append( 'ajax', '1' );

		// Get email for later.
		const email = formEl.querySelector( 'input[type="email"]' )?.value;

		// Hide Notifications.
		this.hideAllNotifications();

		fetch( formEl.action, {
			method: formEl.method,
			body: params,
		} ).then( async( res ) => {
			if ( res.ok ) {
				return await res.json();
			}

			return await Promise.reject( await res.json() );
		} ).then( ( response ) => {
			if ( response && response.success ) {
				formEl.reset();
				formEl.querySelectorAll( '.tao_form_item' ).forEach( ( formItemEl ) => formItemEl.classList.add( 'en_hidden' ) );
				this.showSuccess();

				formEl.dispatchEvent( new CustomEvent( 'newsletter_success.tao', { bubbles: true, detail: { email } } ) );
			} else {
				return Promise.reject( response );
			}
		} ).catch( ( err ) => {
			console.error( err ); // eslint-disable-line no-console
			if ( err && err.data ) {
				if ( err.data.email ) {
					this.showErrorEmail( err.data.email );
				} else if ( err.data.message ) {
					this.showError( err.data.message );
				} else {
					this.showError();
				}
			} else {
				this.showError();
			}
		} );
	}

	static bind( formEl ) {
		formEl.KOE_NEWSLETTER_FORM ??= new NewsletterForm( formEl );
		return formEl.KOE_NEWSLETTER_FORM;
	}

	static trackAction( action, args ) {
		const email = args.email;
		const spec = 'Newsletter';

		TAO_KOE.Tracking.sendIdentifyEvent( spec, email, action );
	}
}

// Init.
TAO_KOE.ready( 'newsletter.js', function() {
	// Initialise Forms.
	const formEls = document.querySelectorAll( 'form.tao_newsletter_form' );
	formEls.forEach( ( formEl ) => {
		NewsletterForm.bind( formEl );
	} );

	// Track Click in Header Menu.
	const metaNavEls = document.querySelectorAll( '.en_header__metanav' );
	metaNavEls.forEach( ( metaNavEl ) => {
		metaNavEl.addEventListener( 'click', ( ev ) => {
			const linkEl = ev.target.closest( 'a' );
			if ( linkEl && '/newsletter-anmeldung/' === linkEl.getAttribute( 'href' ) ) {
				NewsletterForm.trackAction( 'Textlink Menu' );
			}
		} );
	} );

	// Track Click in Mobile Menu.
	const menuEls = document.querySelectorAll( '#menu_mobile' );
	menuEls.forEach( ( menuEl ) => {
		menuEl.addEventListener( 'click', ( ev ) => {
			const linkEl = ev.target.closest( '[data-menu="metanav"] a' );
			if ( linkEl && '/newsletter-anmeldung/' === linkEl.getAttribute( 'href' ) ) {
				NewsletterForm.trackAction( 'Textlink Mobile Menu' );
			}
		} );
	} );

	// Track Click in Footer Menu.
	const footerEls = document.querySelectorAll( '.footer_links' );
	footerEls.forEach( ( footerEl ) => {
		footerEl.addEventListener( 'click', ( ev ) => {
			const linkEl = ev.target.closest( 'a' );
			if ( linkEl && '/newsletter-anmeldung/' === linkEl.getAttribute( 'href' ) ) {
				NewsletterForm.trackAction( 'Textlink Footer' );
			}
		} );
	} );

	document.addEventListener( 'newsletter_success.tao', function( ev ) {
		if ( ev.detail.email ) {
			const email = ev.detail.email;
			if ( ev.target.closest( '#popup_newsletter' ) ) {
				NewsletterForm.trackAction( 'Teaser AddToCart', { email } );
			} else {
				NewsletterForm.trackAction( 'Teaser Block', { email } );
			}
		}
	} );
} );

// Expose via TAO_KOE global.
TAO_KOE.NewsletterForm = NewsletterForm;

export default NewsletterForm;
